import React, { useState, useContext } from 'react';
// mui
import { Dialog, Button, Container, Box, Grid, Typography } from '@mui/material';
// react admin
import {
  useDataProvider,
  useNotify,
  useRefresh,
  useRecordContext,
  useResourceContext
} from 'react-admin';
// loader
import { Loader } from '../../Loader';
import { DialogueContext } from '../../../components/ActionsMenu';

export const DeleteGameRecords = ({ openDialog, handleDialogClose }) => {
  const { handleMenuClose } = useContext(DialogueContext);
  const handleClose = () => {
    handleDialogClose();
    handleMenuClose();
  };
  const record = useRecordContext();
  const resource = useResourceContext();
  const dataProvider = useDataProvider();
  const notify = useNotify();
  const refresh = useRefresh();

  const [loading, setLoading] = useState(false);

  const handleSubmit = async () => {
    setLoading(true);
    try {
      const response = await dataProvider.delete(resource, {
        id: record?.id
      });

      if (response) {
        notify('Game Records deleted successful!', {
          type: 'success'
        });
        handleClose();
        refresh();
        setLoading(false);
      }
    } catch (error) {
      notify(error.message, { type: 'error' });
    } finally {
      setLoading(false);
    }
  };

  return (
    <React.Fragment>
      <Dialog
        fullWidth={true}
        maxWidth="sm"
        open={openDialog}
        onClose={handleClose}
        onKeyDown={(evt) => evt.stopPropagation()}
      >
        {loading && <Loader />}
        <Container component="overlay" maxWidth="sm" sx={{ p: 3 }}>
          <Box className="overlayFormBox">
            <Typography variant="h6" sx={{ mb: 2 }}>
              Confirm Deletion
            </Typography>
            <Typography variant="body1" sx={{ mb: 2 }}>
              Are you sure you want to delete the record? This action cannot be undone.
            </Typography>
            <Grid container spacing={2}>
              <Grid item xs={6}>
                <Button
                  variant="outlined"
                  fullWidth
                  sx={{
                    border: '1px solid rgba(255, 239, 153, 0.20)',
                    color: '#FFF',
                    '&:hover': {
                      border: '1px solid #fff',
                      background: 'none'
                    }
                  }}
                  onClick={handleClose}
                >
                  cancel
                </Button>
              </Grid>
              <Grid item xs={6}>
                <Button
                  onClick={handleSubmit}
                  type="submit"
                  variant="contained"
                  fullWidth
                  sx={{
                    backgroundColor: '#FFD700',
                    color: '#000',
                    fontWeight: 500,
                    '&:hover': {
                      backgroundColor: '#FFA000'
                    }
                  }}
                >
                  Delete
                </Button>
              </Grid>
            </Grid>
          </Box>
        </Container>
      </Dialog>
    </React.Fragment>
  );
};
